import React from "react";
import { inr, inr2, fmtDate } from "../lib/format";

export const InterestEngine = ({ invoice, calc }) => (
  <div data-testid="interest-engine">
    <div className="grid sm:grid-cols-3 gap-px bg-border border border-border mb-5">
      <Stat label="Principal" value={inr(invoice.principal)} />
      <Stat label="Days overdue" value={String(calc.daysOverdue)} />
      <Stat label="Interest accrued" value={inr(calc.totalInterest)} accent />
    </div>

    <div className="bg-white border border-border">
      <div className="px-4 py-2.5 border-b border-border flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
          Section 16 · Monthly rests from {fmtDate(calc.due)}
        </span>
        <span className="font-mono text-[11px] text-muted-foreground">
          Interest = Base × (RBI Rate × 3) × Days ÷ 365
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-wider text-muted-foreground border-b border-border">
              <th className="px-4 py-2 font-medium">Period</th>
              <th className="px-4 py-2 font-medium text-right">Days</th>
              <th className="px-4 py-2 font-medium text-right">RBI Rate</th>
              <th className="px-4 py-2 font-medium text-right">×3 (p.a.)</th>
              <th className="px-4 py-2 font-medium text-right">Base</th>
              <th className="px-4 py-2 font-medium text-right">Interest</th>
            </tr>
          </thead>
          <tbody className="font-mono text-[13px]">
            {calc.rows.map((r, i) => (
              <tr key={i} className="border-b border-border/70 hover:bg-secondary transition-colors duration-150">
                <td className="px-4 py-2 text-ink">{fmtDate(r.from)} → {fmtDate(r.to)}</td>
                <td className="px-4 py-2 text-right text-muted-foreground">{r.days}</td>
                <td className="px-4 py-2 text-right text-muted-foreground">{r.bankRate.toFixed(2)}%</td>
                <td className="px-4 py-2 text-right text-ink">{r.statRate.toFixed(2)}%</td>
                <td className="px-4 py-2 text-right text-muted-foreground">{inr(r.base)}</td>
                <td className="px-4 py-2 text-right text-ink">{inr2(r.interest)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t-2 border-ink font-mono">
              <td className="px-4 py-3 text-sm font-medium text-ink" colSpan={5}>
                Total statutory interest
              </td>
              <td className="px-4 py-3 text-right text-signal font-semibold">{inr(calc.totalInterest)}</td>
            </tr>
            <tr className="bg-secondary font-mono">
              <td className="px-4 py-3 text-sm font-semibold text-ink" colSpan={5}>
                Grand total recoverable (principal + interest)
              </td>
              <td className="px-4 py-3 text-right text-ink text-base font-semibold">{inr(calc.grandTotal)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <p className="mt-3 text-[11px] leading-relaxed text-muted-foreground">
      Rates drawn from a curated, dated RBI Bank Rate table. Compounded with monthly rests
      as required by Section 16. Demo figures — verify with counsel before serving.
    </p>
  </div>
);

const Stat = ({ label, value, accent }) => (
  <div className="bg-white px-4 py-4">
    <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted-foreground">{label}</div>
    <div className={`mt-1 font-mono text-2xl font-semibold ${accent ? "text-signal" : "text-ink"}`}>
      {value}
    </div>
  </div>
);
